import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {windowSize} from "assets/types";

const initialState: windowSize = {width: 0, height: 0};

export const windowSizeSlice = createSlice({
  name: "mobile",
  initialState,
  reducers: {
    setWindowSize: (state, action: PayloadAction<windowSize>) => {
      return state = action.payload;
    },
  },
});

export const { setWindowSize } = windowSizeSlice.actions;
export default windowSizeSlice.reducer;
